import { render, staticRenderFns } from "./TaxonomiaCrear.vue?vue&type=template&id=71d9a7dc"
import script from "./TaxonomiaCrear.vue?vue&type=script&lang=js"
export * from "./TaxonomiaCrear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports